import type { RentalEquipmentStatus, RentalLifeStatus } from "../../api/rental/Rental.typed";

export function rentalStatusLabel(status?: RentalEquipmentStatus | string): string {
  switch (status) {
    case "in_stock":
      return "En stock";
    case "available":
      return "Disponible";
    case "rented":
      return "Loué";
    case "not_rentable":
      return "Non louable";
    default:
      return "—";
  }
}

export function rentalStatusChipColor(
  status?: RentalEquipmentStatus | string,
): "neutral" | "success" | "warning" | "danger" | "primary" {
  switch (status) {
    case "available":
      return "success";
    case "rented":
      return "warning";
    case "not_rentable":
      return "danger";
    default:
      return "neutral";
  }
}

export function rentalLifeStatusLabel(status: RentalLifeStatus): string {
  switch (status) {
    case "draft":
      return "Brouillon";
    case "active":
      return "En cours";
    case "returned":
      return "Retournée";
    case "cancelled":
      return "Annulée";
    default:
      return status;
  }
}

export function rentalLifeStatusColor(
  status: RentalLifeStatus,
): "neutral" | "success" | "warning" | "danger" | "primary" {
  switch (status) {
    case "draft":
      return "neutral";
    case "active":
      return "success";
    case "returned":
      return "primary";
    case "cancelled":
      return "danger";
    default:
      return "neutral";
  }
}

export type RentalTransition = "draft" | "active" | "returned";

// Allowed transitions from the current status. Cancelled rentals are terminal.
export function allowedRentalTransitions(status: RentalLifeStatus): RentalTransition[] {
  switch (status) {
    case "draft":
      return ["active"];
    case "active":
      return ["draft", "returned"];
    case "returned":
      return ["active"];
    default:
      return [];
  }
}

// rentalTransitionBlock mirrors the API validation (router/rental.go).
// Returns the human-readable reason a transition is blocked, or null if it's allowed.
export function rentalTransitionBlock(
  rental: {
    items?: { returned_at?: string | null; return_state?: "returned" | "not_returned" | null }[];
  },
  next: RentalTransition,
): string | null {
  const items = rental.items ?? [];

  if (next === "returned") {
    const open = items.find((it) => !it.returned_at);
    if (open) {
      return "Clôturer chaque équipement (rendu ou non rendu) avant de passer en retour";
    }
  }

  if (next === "active") {
    const lost = items.find((it) => it.return_state === "not_returned");
    if (lost) {
      return "Au moins un équipement est non rendu : démarrage impossible";
    }
  }

  return null;
}
